module.exports = __webpack_public_path__ + "static/media/korthrig.88e9bb1b.mp3";